import { render, staticRenderFns } from "./ContestEntryCopySynopsisSelect.vue?vue&type=template&id=581ec796&scoped=true"
import script from "./ContestEntryCopySynopsisSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContestEntryCopySynopsisSelect.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ContestEntryCopySynopsisSelect.vue?vue&type=style&index=0&id=581ec796&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581ec796",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('581ec796')) {
      api.createRecord('581ec796', component.options)
    } else {
      api.reload('581ec796', component.options)
    }
    module.hot.accept("./ContestEntryCopySynopsisSelect.vue?vue&type=template&id=581ec796&scoped=true", function () {
      api.rerender('581ec796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/event/ContestEntryCopySynopsisSelect.vue"
export default component.exports